"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeedBackCategory = exports.FeedBackRating = void 0;
var FeedBackRating;
(function (FeedBackRating) {
    FeedBackRating[FeedBackRating["NOT_SELECTED"] = -1] = "NOT_SELECTED";
    FeedBackRating[FeedBackRating["CRYING"] = 0] = "CRYING";
    FeedBackRating[FeedBackRating["SAD"] = 1] = "SAD";
    FeedBackRating[FeedBackRating["MEH"] = 2] = "MEH";
    FeedBackRating[FeedBackRating["GOOD"] = 3] = "GOOD";
    FeedBackRating[FeedBackRating["PERFECT"] = 4] = "PERFECT";
})(FeedBackRating = exports.FeedBackRating || (exports.FeedBackRating = {}));
var FeedBackCategory;
(function (FeedBackCategory) {
    FeedBackCategory[FeedBackCategory["NOT_SELECTED"] = -1] = "NOT_SELECTED";
    FeedBackCategory[FeedBackCategory["SUGGESTION"] = 0] = "SUGGESTION";
    FeedBackCategory[FeedBackCategory["NOT_RIGHT"] = 1] = "NOT_RIGHT";
    FeedBackCategory[FeedBackCategory["COMPLIMENT"] = 2] = "COMPLIMENT";
})(FeedBackCategory = exports.FeedBackCategory || (exports.FeedBackCategory = {}));
//# sourceMappingURL=feedback.js.map